import _ from 'lodash';

export default function isObject(v) {
  return _.isObject(v) && !(_.isArray(v) || _.isDate(v) || _.isFunction(v));
}
